// @ts-nocheck
/**
 * Compact uppercase status pill used across the Vote Room (slide-over headers, live-table status
 * column, shareholder portal). Distinct from the more general `Badge` in `WorkflowFormPrimitives`
 * because Vote Room badges use stronger uppercase tracking + a different palette.
 */
const VARIANT_STYLES = {
  approved: 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200',
  disapproved: 'bg-red-50 text-red-700 ring-1 ring-red-200',
  pending: 'bg-amber-50 text-amber-600 ring-1 ring-amber-200',
  abstained: 'bg-gray-100 text-gray-500 ring-1 ring-gray-300',
  viewed: 'bg-blue-50 text-blue-600 ring-1 ring-blue-200',
  secure: 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200',
  closed: 'bg-gray-100 text-gray-500 ring-1 ring-gray-300',
  excluded: 'bg-gray-100 text-gray-500 ring-1 ring-gray-300',
};

export const StatusBadge = ({ children, variant }) => (
  <span
    className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold tracking-wide uppercase ${VARIANT_STYLES[variant] || ''}`}
  >
    {children}
  </span>
);
